import { AppConfigModel } from "../abstract/app-config.model";

export class DiscountType extends AppConfigModel {

    static override CLASS_NAME: string = 'DiscountType';
}
